import React from "react";

export default function OpsLiveTrips() {
  return (
    <div className="rounded-2xl border border-slate-200 p-4">
      <div className="text-lg font-extrabold">Live Trips Monitor</div>
      <p className="mt-1 text-sm text-slate-600">
        Next: in-progress segments (started recently / overtime / no movement) + escalate actions (audited).
      </p>
    </div>
  );
}
